import type { Brands } from '@edreamsodigeo/frontend-core';

interface LogoUrlPair {
  primeLong: string;
  primeShort: string;
  short: string;
}

interface LogoUrlSet {
  default: LogoUrlPair;
  negative: LogoUrlPair;
}

const BRAND_LOGO_MAP: Partial<Record<Brands, LogoUrlSet>> = {
  ED: {
    default: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-long.svg',
      primeShort:
        '/images/onefront/bluestone/ED/logos/logo_prime_short_colour.svg',
      short: '/images/onefront/bluestone/ED/Logo_eDreams_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/ED/prime_logo/ED-logo-prime-negative-long.svg',
      primeShort:
        '/images/onefront/bluestone/ED/logos/logo_prime_short_white.svg',
      short: '/images/onefront/bluestone/ED/eDreams_logo_negative.svg',
    },
  },
  OP: {
    default: {
      primeLong:
        '/images/onefront/bluestone/OP/prime_logo/OP-logo-prime-long.svg',
      primeShort:
        '/images/onefront/bluestone/OP/logos/logo_prime_short_colour.svg',
      short: '/images/onefront/bluestone/OP/Logo_Opodo_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/OP/prime_logo/OP-logo-prime-negative-long.svg',
      primeShort:
        '/images/onefront/bluestone/OP/logos/logo_prime_short_white.svg',
      short: '/images/onefront/bluestone/OP/Opodo_logo_negative.svg',
    },
  },
  GO: {
    default: {
      primeLong:
        '/images/onefront/bluestone/GV/prime_logo/GO-logo-prime-long.svg',
      primeShort:
        '/images/onefront/bluestone/GV/logos/logo_prime_short_colour.svg',
      short: '/images/onefront/bluestone/GV/Logo_GOVoyages_RGB.svg',
    },
    negative: {
      primeLong:
        '/images/onefront/bluestone/GV/prime_logo/GO-logo-prime-negative-long.svg',
      primeShort:
        '/images/onefront/bluestone/GV/logos/logo_prime_short_white.svg',
      short: '/images/onefront/bluestone/GV/GOVoyages_logo_negative.svg',
    },
  },
  TR: {
    default: {
      primeLong: '',
      primeShort: '',
      short: '/images/onefront/bluestone/TL/Logo_Travellink_RGB.svg',
    },
    negative: {
      primeLong: '',
      primeShort: '',
      short: '/images/onefront/bluestone/TL/Travellink_logo_negative.svg',
    },
  },
};

const fallbackLogo = '';

interface BrandLogoArgs {
  brand: Brands;
  theme: keyof LogoUrlSet;
  type: keyof LogoUrlPair;
}

export const useBrandLogoUrl = (args?: BrandLogoArgs): string => {
  let result: string | undefined = undefined;
  if (args) {
    const { brand, theme, type } = args;
    result = BRAND_LOGO_MAP[brand]?.[theme]?.[type];
  }
  return result || fallbackLogo;
};
